import { render } from "./Client.html?vue&type=template&id=04097742&scoped=true&ts=true"
import script from "./Client.ts?vue&type=script&lang=ts"
export * from "./Client.ts?vue&type=script&lang=ts"

import "./Client.css?vue&type=style&index=0&id=04097742&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04097742"]])

export default __exports__